import { Link } from "react-router-dom";

import imgDestaque1 from "../../../img/blog-1.jpg";
import imgDestaque2 from "../../../img/blog-2.jpg";
import imgDestaque3 from "../../../img/blog-3.jpg";


const DestaquesCards = () => {
    return (
        <div className="row g-4 justify-content-center">
            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                <div className="blog-item rounded">
                    <div className="blog-img">
                        <img src={imgDestaque1} className="img-fluid w-100" alt="" />
                    </div>
                    <div className="blog-centent p-4">
                        <Link to="/Treinamentos/1" className="h4">Protocolos</Link>
                        <p className="my-4">Conjunto de orientações clínicas baseadas em evidências, elaboradas para
                            padronizar e garantir a qualidade do cuidado
                            prestado aos recém-nascidos em situações críticas.</p>
                        <Link to="/Treinamentos/1" className="btn btn-primary rounded-pill text-white py-2 px-4 mb-1">Ler Mais</Link>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                <div className="blog-item rounded">
                    <div className="blog-img">
                        <img src={imgDestaque2} className="img-fluid w-100" alt="" />
                    </div>
                    <div className="blog-centent p-4">
                        <Link to="/Treinamentos/3" className="h4">Diretrizes</Link>
                        <p className="my-4">Princípios que norteiam a conduta da equipe multiprofissional, promovendo a
                            uniformidade, a segurança e a humanização no
                            atendimento neonatal.</p>
                        <Link to="/Treinamentos/3" className="btn btn-primary rounded-pill text-white py-2 px-4 mb-1">Ler Mais</Link>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                <div className="blog-item rounded">
                    <div className="blog-img">
                        <img src={imgDestaque3} className="img-fluid w-100" alt="" />
                    </div>
                    <div className="blog-centent p-4">
                        <Link to="/Treinamentos/4" className="h4">Documentações</Link>
                        <p className="my-4">Materiais complementares com arquivos técnicos reunidos
                            para fortalecer o aprendizado contínuo e a
                            capacitação dos profissionais atuantes na UTI Neonatal.</p>
                        <Link to="/Treinamentos/4" className="btn btn-primary rounded-pill text-white py-2 px-4 mb-1">Ler Mais</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DestaquesCards;